export const employeesGroupsApiErrorsTranslations = {
  RESOURCE_ALREADY_EXISTS:
    'employeesGroups:common.createEmployeesGroupDialog.resourceAlreadyExists',
  RESOURCE_NOT_FOUND:
    'employeesGroups:spaceGroups.unassignSpaceGroupFromEmployeeGroupDialog.resourceNotFound',
} as const;

export const employeesGroupsEditDefaultApiErrorsTranslations = {
  RESOURCE_ALREADY_EXISTS:
    'employeesGroups:common.editEmployeesGroup.default.resourceAlreadyExists',
} as const;
